<template>
  <a-modal
    :visible="visible"
    :title="isEdit ? 'Edit Task Category' : 'Create Task Category'"
    centered
    :mask-closable="false"
    width="500px"
    @cancel="handleCancel"
  >
    <a-form
      ref="formRef"
      :model="formState"
      :rules="rules"
      layout="vertical"
    >
      <a-form-item label="Name" name="name">
        <a-input
          v-model:value="formState.name"
          placeholder="Enter category name"
          :maxlength="100"
        />
      </a-form-item>
      <a-form-item label="Description" name="description">
        <a-textarea
          v-model:value="formState.description"
          placeholder="Enter category description (optional)"
          :rows="4"
        />
      </a-form-item>
    </a-form>
    <template #footer>
      <a-button @click="handleCancel">Cancel</a-button>
      <a-button
        type="primary"
        :loading="isSubmitting"
        @click="handleSubmit"
      >
        {{ isEdit ? 'Update' : 'Create' }}
      </a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    category: {
      type: Object,
      default: null,
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'submit'],
  data() {
    return {
      formState: {
        name: '',
        description: '',
      },
      rules: {
        name: [
          { required: true, message: 'Please enter a category name', trigger: 'blur' },
          { max: 100, message: 'Name cannot exceed 100 characters', trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.category;
    },
  },
  watch: {
    visible(newVal) {
      if (newVal && this.category) {
        this.formState.name = this.category.name || '';
        this.formState.description = this.category.description || '';
      } else if (!newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.formState = {
        name: '',
        description: '',
      };
      this.$refs.formRef?.resetFields();
    },
    handleCancel() {
      this.$emit('close');
    },
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate();
        this.$emit('submit', {
          name: this.formState.name.trim(),
          description: this.formState.description?.trim() || null,
        });
      } catch (error) {
        // Validation failed
      }
    },
  },
};
</script>
